import { useParams } from 'react-router-dom';

type InstructionUrlParameters = {
  instructionId: string;
};

export const useInstructionIdFromParams = (): number => {
  const { instructionId } = useParams<InstructionUrlParameters>();
  return Number(instructionId);
};
